import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'objectToArrayPipe'
})
export class ObjectToArrayPipe implements PipeTransform {
  transform(value: any): any {
    if (!value) return [];
    return Object.entries(value).map(([key, val]) => [key, val]);
  }
}
